import { preferenceTypes } from '../../types';

export const setPreferences = data => ({
  type: preferenceTypes.SET_PREFERENCES,
  payload: { data }
});
export const updatePreferences = data => ({
  type: preferenceTypes.UPDATE_PREFERENCES,
  payload: { data }
});
